export const environment = {
  production: true,
  pathApi: 'https://adora.hes.bpsafrica.com:8443',
  githubSha: '25de62a5864845ce072adb1c615e9f40714cdece',
  gmap_key: 'AIzaSyD3D0SdHzMW0BEUoDFRGWgFyrRK1fnd2LQ',
  environmentName: 'production',
  useOpenIddict: JSON.parse('true'),
};
